import { Input, Select, SelectProps, InputProps } from "@material-ui/core";
import React, { FC } from "react";

import { ExpandMore } from "@material-ui/icons";
import { TheCycleverseTheme } from "src/theme";
import { makeStyles } from "@material-ui/core/styles";

const useStylesForSelector = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    width: "160px",
    backgroundColor: theme.palette.common.white,
    borderRadius: "4px",
    fontWeight: 900,
    paddingLeft: 8,
    "&:focus": {
      backgroundColor: theme.palette.common.white,
      borderRadius: "4px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100px",
      textAlign: "center",
    },
  },

  selectMenu: {
    padding: "10px",
    paddingLeft: "24px",
  },

  icon: {
    marginRight: "10px",
  },
}));

const useStylesForInput = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderRadius: "4px",
    fontWeight: 900,
    height: "38px",
  },
  input: (result) => {
    return {
      paddingLeft: "24px",
      paddingRight: "24px",
      color: result ? theme.calculatorOrangeBoldColor : theme.palette.secondary.main,
      width: "160px",
      textAlign: "center",
      [theme.breakpoints.down("sm")]: {
        width: "100px",
        textAlign: "center",
      },
    };
  },
}));

const useStylesForSmallInput = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderRadius: "4px",
    fontWeight: 900,
    height: "38px",
  },
  input: {
    paddingLeft: "17px",
    paddingRight: "20px",
    color: theme.palette.secondary.main,
    width: "110px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      width: "60px",
      textAlign: "center",
    },
  },
}));
export const SelectorComponent: FC<SelectProps> = ({ children, ...props }) => {
  const classes = useStylesForSelector();

  return (
    <Select disableUnderline IconComponent={ExpandMore} classes={classes} {...props}>
      {children}
    </Select>
  );
};

export const InputComponent = ({ name, onChange, result, value, ...props }) => {
  const classes = useStylesForInput(result);

  return <Input value={value} name={name} onChange={onChange} disableUnderline={true} classes={classes} {...props} />;
};

type ComponentProps = InputProps & { result?: string };

export const SmallInputComponent: FC<ComponentProps> = ({ name, onChange, result, value, disabled, ...props }) => {
  const classes = useStylesForSmallInput();

  return (
    <Input
      value={value}
      name={name}
      onChange={onChange}
      disableUnderline={true}
      disabled={disabled}
      classes={classes}
      {...props}
    />
  );
};
